import { put, call } from "redux-saga/effects"

import { rsf } from '../../firebase'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { userActions } from 'reduxModules/actions/UserActions'

export function* emailSignInSaga(action) {
  const { responseSuccess, responseFailure, data } = action

  try {
    const { login, password } = data
    const { code, user } = yield call(rsf.auth.signInWithEmailAndPassword, login, password)

    if (!code) {
      yield put(userActions.getUserData(user.uid))
      yield put(userActions.setUserHistory(user))
      yield put(responseSuccess({ login, password }))
    } else {
      /* eslint-disable */
      switch (code) {
        case 'auth/invalid-email':
          yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Невірний логін' }))
          break
        case 'auth/wrong-password':
          yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Невірний пароль' }))
          break
        case 'auth/user-not-found':
          yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Введеного користувача не знайдено' }))
          break
        case 'auth/too-many-requests':
          yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Вхід тимчасово заблокований' }))
          break
        case 'auth/network-request-failed':
          yield put(snackbarActions.showSnackbar({ 
            type: 'error',
            message: 'Сервер недоступний. Перевірте з\'єднання з інтернетом і перезавантажте сторінку' 
          }))
          break
        default: 
          yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Сталась помилка, Повторіть спробу!' }))
      }
      /* eslint-enable */
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    /*eslint-disable*/
    switch (err.code) {
      case 'auth/invalid-email':
        yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Невірний логін' }))
        break
      case 'auth/wrong-password':
        yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Невірний пароль' }))
        break
      case 'auth/user-not-found':
        yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Введеного користувача не знайдено' }))
        break
      case 'auth/too-many-requests':
        yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Вхід тимчасово заблокований' }))
        break
      case 'auth/network-request-failed':
        yield put(snackbarActions.showSnackbar({ 
          type: 'error',
          message: 'Сервер недоступний. Перевірте з\'єднання з інтернетом і перезавантажте сторінку' 
        }))
        break
      default: 
        yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Сталась помилка, Повторіть спробу!' }))
    }
    /* eslint-enable */
  }
}

export function* signOutSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    yield call(rsf.auth.signOut)

    yield put(responseSuccess())
    yield put(userActions.clearUserData())
    localStorage.removeItem('persist:root')
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({ type: 'error', message: 'Сталась помилка, Повторіть спробу!' }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/AuthSagas.js